/**
 * Checks if the view is currently in mobile view
 * @returns true if the view is in mobile view, else false
 */
export default function isMobileView(): boolean {
    return window.innerWidth <= 768;
}